import { defineComponent as i, openBlock as l, createElementBlock as o, mergeProps as u, unref as e, renderSlot as g, createElementVNode as n, createCommentVNode as m } from "vue";
import { useScalarIcon as f } from "../hooks/useScalarIcon.js";
const A = { key: 0 }, h = { key: 1 }, k = { key: 2 }, M = { key: 3 }, Z = { key: 4 }, w = { key: 5 }, y = {
  name: "ScalarIconGreaterThan"
}, V = /* @__PURE__ */ i({
  ...y,
  props: {
    label: {},
    weight: {}
  },
  setup(r) {
    const s = r, { bind: d, weight: a } = f(s);
    return (p, t) => (l(), o("svg", u({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, e(d)), [
      g(p.$slots, "default"),
      e(a) === "bold" ? (l(), o("g", A, t[0] || (t[0] = [
        n("path", { d: "M228,128a12,12,0,0,1-6.86,10.84l-152,72a12,12,0,0,1-10.27-21.69L188,128,58.87,66.85A12,12,0,0,1,69.14,45.16l152,72A12,12,0,0,1,228,128Z" }, null, -1)
      ]))) : e(a) === "duotone" ? (l(), o("g", h, t[1] || (t[1] = [
        n("path", {
          d: "M216,128,64,200V56Z",
          opacity: "0.2"
        }, null, -1),
        n("path", { d: "M224,128a8,8,0,0,1-4.58,7.23l-152,72a8,8,0,1,1-6.85-14.46L197.31,128,60.58,63.23a8,8,0,1,1,6.85-14.46l152,72A8,8,0,0,1,224,128Z" }, null, -1)
      ]))) : e(a) === "fill" ? (l(), o("g", k, t[2] || (t[2] = [
        n("path", { d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM187.35,135.26l-104,48a8,8,0,0,1-6.7-14.52L164.91,128,76.65,87.26a8,8,0,1,1,6.7-14.52l104,48a8,8,0,0,1,0,14.52Z" }, null, -1)
      ]))) : e(a) === "light" ? (l(), o("g", M, t[3] || (t[3] = [
        n("path", { d: "M222,128a6,6,0,0,1-3.43,5.42l-152,72a6,6,0,1,1-5.14-10.84L202,128,61.43,61.42a6,6,0,1,1,5.14-10.84l152,72A6,6,0,0,1,222,128Z" }, null, -1)
      ]))) : e(a) === "regular" ? (l(), o("g", Z, t[4] || (t[4] = [
        n("path", { d: "M224,128a8,8,0,0,1-4.58,7.23l-152,72a8,8,0,1,1-6.85-14.46L197.31,128,60.58,63.23a8,8,0,1,1,6.85-14.46l152,72A8,8,0,0,1,224,128Z" }, null, -1)
      ]))) : e(a) === "thin" ? (l(), o("g", w, t[5] || (t[5] = [
        n("path", { d: "M220,128a4,4,0,0,1-2.29,3.62l-152,72A3.85,3.85,0,0,1,64,204a4,4,0,0,1-1.71-7.62L206.66,128,62.29,59.62a4,4,0,0,1,3.42-7.23l152,72A4,4,0,0,1,220,128Z" }, null, -1)
      ]))) : m("", !0)
    ], 16));
  }
});
export {
  V as default
};
